<template>
  <main>
    <v-card v-if="loaded" style=" border-radius:10px">
      <v-card-title style="font-size:1rem">
        {{ $t("comparesAttendace_title") }}
      </v-card-title>
      <v-card-text>
        <PieChart :chartData="chartData" :options="options" />
      </v-card-text>
    </v-card>
    <v-col v-else cols="12" class="text-center">
      <v-progress-circular
        size="100"
        class="text-center"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-col>
  </main>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";

export default {
  name: "CampersAttendanceStatistics",
  components: {
    PieChart: () => import("@/components/PieChart")
  },
  data() {
    return {
      loaded: false,
      chartData: {
        labels: [],
        datasets: [{ backgroundColor: [], data: [] }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        plugins: {
          datalabels: {
            color: "white",
            textAlign: "center",
            font: {
              weight: "bold",
              size: 16
            },
            formatter: (value, ctx) => {
              let sum = 0;
              let dataArr = ctx.chart.data.datasets[0].data;
              dataArr.map(data => {
                sum += data;
              });
              let percentage = ((value * 100) / sum).toFixed(0) + "%";
              return percentage;
            }
          }
        }
      }
    };
  },
  methods: {
    handleGetData(query) {
      this.loaded = false;
      IndexData({
        reqName: "/dashboard/campers-attendance-statistics",
        query
      }).then(res => {
        const { data } = res.data;
        this.chartData.labels = data.map(el => el.attendance_percentage);
        this.chartData.datasets[0].data = data.map(
          el => el.attendance_percentage
        );
        const colores = data.map((el, index) => `#e289${index + 1}f`);
        this.chartData.datasets[0].backgroundColor = colores;
        this.loaded = true;
      });
    }
  },
  watch: {
    $route: {
      handler({ query }) {
        this.handleGetData(query);
      },
      immediate: true
    }
  }
};
</script>
